import React from 'react';

function CompanyIntro() {
  return (
    <section className="section-padding sub-bg">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 md-mb50">
            <div className="sec-head">
              <h6 className="sub-title main-color mb-15">Kanus Digital Hakkında</h6>
              <h3 className="mb-30">
                Dijital dönüşümde <span className="fw-200">güvenilir ortağınız.</span>
              </h3>
              <p className="p-color">
                Kanus Digital, işletmelerin dijital dünyada güçlü bir varlık
                oluşturmasına yardımcı olan yenilikçi bir dijital ajans olarak
                hizmet vermektedir. Web tasarım ve geliştirme, dijital pazarlama,
                marka kimliği ve SEO alanlarında bütünleşik çözümler sunuyoruz.
              </p>
              <p className="p-color mt-20">
                Her projeyi özgün bir bakış açısıyla ele alıyor; müşterilerimizin
                hedeflerine ulaşmaları için strateji, yaratıcılık ve teknolojiyi
                bir araya getiriyoruz. Müşteri memnuniyeti ve şeffaf iletişim,
                çalışma sürecimizin temelini oluşturuyor.
              </p>
              <a href="/page-about" className="butn butn-bord radius-30 mt-40">
                <span>Daha Fazla Bilgi</span>
              </a>
            </div>
          </div>
          <div className="col-lg-5 offset-lg-1">
            <div className="row">
              <div className="col-6">
                <div className="item bord-thin-top pt-30 mb-30">
                  <h3 className="fw-300 main-color mb-10">%100</h3>
                  <p className="p-color fz-14">Müşteri Odaklı Yaklaşım</p>
                </div>
              </div>
              <div className="col-6">
                <div className="item bord-thin-top pt-30 mb-30">
                  <h3 className="fw-300 main-color mb-10">7/24</h3>
                  <p className="p-color fz-14">Destek ve İletişim</p>
                </div>
              </div>
              <div className="col-6">
                <div className="item bord-thin-top pt-30">
                  <h3 className="fw-300 main-color mb-10">Hızlı</h3>
                  <p className="p-color fz-14">Teslimat ve Kurulum</p>
                </div>
              </div>
              <div className="col-6">
                <div className="item bord-thin-top pt-30">
                  <h3 className="fw-300 main-color mb-10">Özel</h3>
                  <p className="p-color fz-14">Tasarım ve Geliştirme</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CompanyIntro;
